import { AppFormDialog } from '@app/shared/components/AppFormDialog';
import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { AppButton } from '@app/shared/components/AppButton';
import { RoleProtectedButton } from '@app/shared/components/RoleBasedRoute/components/RoleProtectedButton';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectMarginSystemConfigurationCreatingState,
  selectMarginSystemConfigurationsCreationModalState,
  setMarginSystemConfigurationsModalOpenedAction,
} from '@app/store/volume-driver/margin-system-configurations';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  MarginSystemForm,
  MarginSystemFormData,
} from './components/MarginSystemForm';

interface Props {
  onBack?: () => void;
  onSubmit: (payload: MarginSystemFormData) => void;
}

const FORM_ID = 'MARGIN_SYSTEM_CONFIGURATION_FORM';

export const MarginSystemFormDialog = (props: Props) => {
  const { onBack, onSubmit } = props;

  const dispatch = useDispatch();

  const isOpened = useSelector(
    selectMarginSystemConfigurationsCreationModalState
  );

  const isLoading = useSelector(selectMarginSystemConfigurationCreatingState);

  const closeModal = React.useCallback(() => {
    dispatch(setMarginSystemConfigurationsModalOpenedAction({ opened: false }));
  }, [dispatch]);

  const handleBackClick = React.useCallback(() => {
    closeModal();

    onBack && onBack();
  }, [closeModal, onBack]);

  const handleSubmit = React.useCallback(
    (payload: MarginSystemFormData) => {
      onSubmit(payload);
    },
    [onSubmit]
  );

  return (
    <AppFormDialog
      isOpened={isOpened}
      isLoading={isLoading}
      title="Add system configuration"
      content={<MarginSystemForm onSubmit={handleSubmit} formId={FORM_ID} />}
      actions={
        <Box p={2} width="100%">
          <Grid container wrap="nowrap">
            <Grid item xs={12}>
              <IconButton
                color="primary"
                title="Back to system selection"
                onClick={handleBackClick}
              >
                <ArrowBackIcon />
              </IconButton>
            </Grid>
            <Grid item container alignItems="center">
              <Grid container spacing={2} wrap="nowrap" alignContent="center">
                <Grid item>
                  <AppButton color="default" onClick={closeModal}>
                    Cancel
                  </AppButton>
                </Grid>
                <Grid item>
                  <RoleProtectedButton
                    type="submit"
                    color="primary"
                    form={FORM_ID}
                  >
                    <pre>Add system</pre>
                  </RoleProtectedButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      }
    />
  );
};
